import { Box } from '@mui/material';
import React, { ReactElement } from 'react';
import { leaderStatusLabel, LeaderUiStatus } from './deriveLeaderUiStatus';

const ACTIVE_COLOR = '#2E7D32';
const PENDING_COLOR = '#383838';

export function LeadershipStatusPill ({
  status,
}: {
  status: LeaderUiStatus;
}): ReactElement {
  const isActive = status === 'active';
  const label = leaderStatusLabel(status);
  const pillColor = isActive ? ACTIVE_COLOR : PENDING_COLOR;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: '16px',
        py: '4px',
        borderRadius: '9999px',
        border: `1px solid ${pillColor}`,
        color: pillColor,
        fontFamily: '\'Poppins\', sans-serif',
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '18px',
        letterSpacing: 0,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Box>
  );
}
